import { useLocation } from 'react-router-dom'
import { Menu, Search, Bell, HelpCircle } from 'lucide-react'
import './Header.css'

const pageTitles = { '/email-accounts': 'Email Accounts', '/contacts': 'Contacts', '/contacts/add': 'Add Contacts', '/templates': 'Templates', '/campaigns': 'Campaigns', '/inbox-placement': 'Inbox Placement Tester', '/inbox-placement/new': 'Inbox Placement Tester', '/inbox': 'Inbox', '/co-pilot': 'Co-Pilot', '/reports': 'Reports', '/settings': 'Settings', '/dashboard': 'Dashboard', '/calendar': 'Campaign Calendar', '/api-docs': 'API Documentation' }

function Header({ onMenuClick }) {
  const location = useLocation()
  const currentTitle = pageTitles[location.pathname]
    || (location.pathname.startsWith('/inbox-placement/') ? 'Inbox Placement Tester' : null)
    || 'Dashboard'

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onMenuClick} aria-label="Toggle menu"><Menu size={22} /></button>
        <div className="page-title"><h1>{currentTitle}</h1></div>
      </div>
      <div className="header-center">
        <div className="search-container">
          <Search size={18} className="search-icon" />
          <input type="text" placeholder="Search anything..." className="search-input" />
          <span className="search-shortcut">⌘K</span>
        </div>
      </div>
      <div className="header-right">
        <button className="header-btn" title="Help"><HelpCircle size={20} /></button>
        <button className="header-btn notification" title="Notifications"><Bell size={20} /><span className="notification-dot"></span></button>
      </div>
    </header>
  )
}

export default Header
